import { recurrenceApi } from "./axios"; // agrega recurrenceApi a tu archivo axios
import { useQuery } from "@tanstack/react-query";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { ServiceResponseI, DataI } from "../../interfaces";
import {
  GetRecurrenceParamsI,
  ListRecurrenceI,
  NewRecurrenceI,
  OneRecurrenceForFrontI,
} from "@interfaces";
import { AxiosError } from "axios";

const getRecurrences = async ({
  pagination,
  sorting,
  globalFilter,
}: GetRecurrenceParamsI): Promise<ServiceResponseI<DataI<ListRecurrenceI>>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const params = new URLSearchParams();
    params.append("page", (pagination.pageIndex + 1).toString());
    params.append("limit", pagination.pageSize.toString());
    params.append("search", globalFilter ?? "");
    params.append("sorting", JSON.stringify(sorting ?? []));

    const { data } = await recurrenceApi.get<
      ServiceResponseI<DataI<ListRecurrenceI>>
    >("", { params, headers: { Authorization: validateToken } });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const recurrenceById = async (
  id: string,
): Promise<ServiceResponseI<OneRecurrenceForFrontI>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const { data } = await recurrenceApi.get<
      ServiceResponseI<OneRecurrenceForFrontI>
    >(`/${id}`, { headers: { Authorization: validateToken } });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const recurrencePost = async (
  payload: NewRecurrenceI,
): Promise<ServiceResponseI<string>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const { data } = await recurrenceApi.post<ServiceResponseI<string>>(
      "",
      payload,
      { headers: { Authorization: validateToken } },
    );
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const recurrencePut = async (
  id: string,
  payload: NewRecurrenceI,
): Promise<ServiceResponseI<string>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const { data } = await recurrenceApi.put<ServiceResponseI<string>>(
      `/${id}`,
      payload,
      { headers: { Authorization: validateToken } },
    );
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const recurrenceDelete = async (
  id: string,
): Promise<ServiceResponseI<string>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const { data } = await recurrenceApi.delete<ServiceResponseI<string>>(
      `/${id}`,
      { headers: { Authorization: validateToken } },
    );
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const useRecurrences = ({
  pagination,
  sorting,
  globalFilter,
}: GetRecurrenceParamsI) => {
  const recurrencesQuery = useQuery(
    ["recurrences", { pagination, sorting, globalFilter }],
    () => getRecurrences({ pagination, sorting, globalFilter }),
    { refetchOnWindowFocus: false, keepPreviousData: true },
  );
  return { recurrencesQuery };
};